import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { saveUserDetails, setToken } from '../../Redux/userSlice';
import { fetchUserProfile } from '../services/influancerService';
import Navbar from '../../components/Navbar';
import { INFLUENCER_BASE } from '../constants';

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const loginPath = `${INFLUENCER_BASE}/login`;
    const dashboardPath = `${INFLUENCER_BASE}/dashboard`;
    const userDetailsPath = `${INFLUENCER_BASE}/user-details`;

    useEffect(() => {
        const handleAuth = async () => {
            try {
                const params = new URLSearchParams(location.search);
                const token = params.get('token');
                const isNewUser = params.get('isNewUser') === 'true';
                const username = params.get('username');
                const userId = params.get('userId');
                const errorParam = params.get('error');
                const redirectTo = params.get('redirectTo');

                if (errorParam) {
                    setError(errorParam);
                    setTimeout(() => navigate(loginPath), 3000);
                    return;
                }

                if (!token || !userId || !username) {
                    setError('Missing required authentication data');
                    console.error('Missing data:', { token, userId, username });
                    setTimeout(() => navigate(loginPath), 3000);
                    return;
                }

                localStorage.setItem('token', token);
                dispatch(setToken(token));

                const response = await fetchUserProfile();
                if (response.data.success) {
                    localStorage.setItem('token', token);
                    localStorage.setItem('username', username);
                    localStorage.setItem('userId', userId);
                    dispatch(saveUserDetails(response.data.user));

                    if (isNewUser) {
                        if (redirectTo) {
                            navigate(`${userDetailsPath}?redirectTo=${encodeURIComponent(redirectTo)}`);
                        } else {
                            navigate(userDetailsPath);
                        }
                    } else {
                        if (response.data.user?.isProfileComplete) {
                            if (redirectTo) {
                                navigate(redirectTo);
                            } else {
                                navigate(dashboardPath);
                            }
                        } else {
                            if (redirectTo) {
                                navigate(`${userDetailsPath}?redirectTo=${encodeURIComponent(redirectTo)}`);
                            } else {
                                navigate(userDetailsPath);
                            }
                        }
                    }
                } else {
                    throw new Error('Failed to fetch user profile');
                }

            } catch (err) {
                console.error('Auth callback error:', err);
                setError('Authentication failed. Please try again.');
                setTimeout(() => navigate(loginPath), 3000);
            }
        };

        handleAuth();
    }, [navigate, location, dispatch]);

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                    <p className="font-bold">Error</p>
                    <p>{error}</p>
                    <p className="text-sm">Redirecting to login...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-orange-500 relative">
            {/* Top Status Bar Mock */}
            {/* Connecting Icon */}
            <div className="animate-spin mb-4">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4.354a8.001 8.001 0 11-4.244 14.907M4.354 12a8.001 8.001 0 0114.907-4.244"
                    />
                </svg>
            </div>

            {/* Connecting Text */}
            <div className="text-center text-white">
                <div className="flex flex-col items-center justify-center">
                    <Navbar />
                    <h1 className="text-xl font-semibold">Processing your login</h1>
                    <p className="text-sm mt-2">This shouldn't take long</p>
                </div>
            </div>
        </div>
    );
};

export default AuthCallback;


// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import { saveUserDetails } from '../Redux/userSlice';
// import { fetchUserProfile } from '../services/influancerService';

// const AuthCallback = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const dispatch = useDispatch();
//     const [error, setError] = useState('');

//     useEffect(() => {
//         const handleAuth = async () => {
//             try {
//                 const params = new URLSearchParams(location.search);
//                 const token = params.get('token');
//                 const isNewUser = params.get('isNewUser') === 'true';
//                 const username = params.get('username');
//                 const userId = params.get('userId');
//                 const error = params.get('error');

//                 if (error) {
//                     setError(error);
//                     setTimeout(() => navigate('/login'), 3000);
//                     return;
//                 }

//                 if (!token || !userId || !username) {
//                     setError('Missing required authentication data');
//                     console.error('Missing data:', { token, userId, username });
//                     setTimeout(() => navigate('/login'), 3000);
//                     return;
//                 }

//                 // Store token in localStorage
//                 localStorage.setItem('token', token);

//                 // Fetch complete user profile
//                 const response = await fetchUserProfile();
//                 if (response.data.success) {
//                     // Store user data in localStorage
//                     localStorage.setItem('username', username);
//                     localStorage.setItem('userId', userId);

//                     // Store user data in Redux
//                     dispatch(saveUserDetails({
//                         data: {
//                             ...response.data.user,
//                             token,
//                             username,
//                             userId
//                         }
//                     }));

//                     // Check for invitation redirect
//                     const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
//                     if (redirectAfterLogin) {
//                         localStorage.removeItem('redirectAfterLogin');
//                         navigate(redirectAfterLogin);
//                     } else {
//                         // Default navigation based on user status
//                         navigate(isNewUser ? '/user-details' : '/dashboard');
//                     }
//                 } else {
//                     throw new Error('Failed to fetch user profile');
//                 }
//             } catch (err) {
//                 console.error('Auth callback error:', err);
//                 setError('Authentication failed. Please try again.');
//                 setTimeout(() => navigate('/login'), 3000);
//             }
//         };

//         handleAuth();
//     }, [navigate, location, dispatch]);

//     if (error) {
//         return (
//             <div className="min-h-screen flex items-center justify-center">
//                 <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
//                     <p className="font-bold">Error</p>
//                     <p>{error}</p>
//                     <p className="text-sm">Redirecting to login...</p>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="flex flex-col items-center justify-center min-h-screen bg-orange-500 relative">
//         {/* Top Status Bar Mock */}
//         {/* Connecting Icon */}
//         <div className="animate-spin mb-4">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-16 w-16 text-white"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M12 4.354a8.001 8.001 0 11-4.244 14.907M4.354 12a8.001 8.001 0 0114.907-4.244"
//             />
//           </svg>
//         </div>

//         {/* Connecting Text */}
//         <div className="text-center text-white">
//           <h1 className="text-xl font-semibold">Processing your login</h1>
//           <p className="text-sm mt-2">This shouldn't take long</p>
//         </div>
//       </div>
//     );
// };

// export default AuthCallback; 